import { call, select, put } from 'redux-saga/effects'
import * as _ from 'lodash'

import { isConnected, showErrorMessage, trimObj } from '../utils'
import { logoutUser } from '../auth/index.web'

function* callServer(
  apiFunction: any,
  reqData: any,
  showError = false,
  id = null
) {
  if (isConnected) {
    reqData = trimObj(reqData || {})
    const response = yield call(apiFunction, reqData, reqData.id || id)
    // if (__DEV__)console.tron.log({ApiResponse : response});
    // if (__DEV__)console.log({ApiResponse : response});
    const {
      status = 200,
      data: resData = null,
      ok = false,
      problem = 'TIMEOUT_ERROR'
    } = response || {}

    if (ok && status && status >= 200 && status <= 300) {
      return { error: false, res: resData, statusCode: status }
    } else {
      let message = ''
      if (resData) {
        if (typeof resData.error === 'object' && resData.error.message) {
          message = resData.error.message
        } else if (resData.message) {
          message = resData.message
        } else if (resData.msg) {
          message = resData.msg
        } else if (resData.error) {
          message = resData.error
        } else if (_.isString(resData)) {
          message = resData
        } else {
          message = getMessage(resData)
        }
      } else {
        message = getMessage(problem)
      }
      if (showError) {
        showErrorMessage(message)
      }
      if (status === 401) {
        const { token } = yield select(state => state.auth)
        if (token) {
           yield put(logoutUser())
        }
      }
      const { data = {} } = resData
      return { res: {error: true, message, statusCode: status, data }}
    }
  } else {
    const message = 'Network Error. No internet connection.'
    if (showError) {
      showErrorMessage(message)
    }
    return { res: {error: true, message, statusCode: 503 }}
  }
}

const getMessage = (error: string) => {
  if (error === 'TIMEOUT_ERROR') {
    return 'No Response From Server.'
  } else if (error === 'CONNECTION_ERROR') {
    return 'Server Is Not Available.'
  } else if (error === 'NETWORK_ERROR') {
    return 'Network not available.'
  } else {
    return 'Something went wrong. Please try again'
  }
}

export default {
  callServer
}
